<template>
  <div class="complete-callout-block callout-block">

    <template v-if="nextPage && pageComplete">
      <div class="callout-block-heading">
        <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
          <path fill="#0061A6" d="M20.59,35.88c-0.51,0-1.02-0.2-1.41-0.59l-6.44-6.44c-0.78-0.78-0.78-2.05,0-2.83c0.78-0.78,2.05-0.78,2.83,0l5.02,5.02l13.84-13.84c0.78-0.78,2.05-0.78,2.83,0c0.78,0.78,0.78,2.05,0,2.83L22.01,35.29C21.62,35.68,21.1,35.88,20.59,35.88z"/>
          <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
          <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
          <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
        </svg>
        <div class="callout-block-heading-copy">
          <div class="callout-block-heading-copy-eyebrow">{{ $t('principle-complete') }}</div>
          <div class="callout-block-heading-copy-title">{{ currentPage.name.get() }}</div>
        </div>
      </div>

      <div class="callout-block-progress-section">
        <div class="callout-block-progress-section-eyebrow">{{ $t('progress') }}</div>
        <div class="callout-block-progress-section-row" v-for="page in form.pages">
          <div class="row-content">
            <div class="callout-block-progress-section-meta">
              <span class="callout-block-progress-section-name">{{ page.name.get() }}</span>
              <span class="callout-block-progress-section-percent">{{ page.percentComplete }}%&nbsp;{{ $t('percent-complete') }}</span>
            </div>

            <div class="callout-block-progress-bar-track" :style="`--progress: ${page.percentComplete}`">
              <div class="callout-block-progress-bar-bar">
                <div class="callout-block-progress-bar-gradient"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="callout-block-actions">
        <div class="callout-block-actions-label">
          <div class="callout-block-actions-label-eyebrow">{{ $t('next-principle') }}</div>
          <div class="callout-block-actions-label-title">{{ nextPage.name.get() }}</div>
        </div>
        <div class="callout-block-actions-buttons">
          <router-link :to="`/${getLocale()}/form/${nextPage.id}?id=${submission.id}`" >
            <button type="button" class="rect">{{ $t('continue') }}</button>
          </router-link>
        </div>
      </div>
    </template>

    <template v-else-if="!pageComplete">
      <div class="callout-block-heading">
        <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
          <path fill="#0061A6" d="M24.31,29.35c-0.74,0-1.28-0.54-1.38-1.28l-0.32-2.75c-0.13-0.86,0.38-1.5,1.25-1.6c3.01-0.29,4.67-1.44,4.67-3.46V20.2c0-1.79-1.38-3.04-3.68-3.04c-1.7,0-3.07,0.61-4.35,1.76c-0.32,0.26-0.74,0.45-1.18,0.45c-0.99,0-1.79-0.8-1.79-1.76c0-0.48,0.19-0.99,0.64-1.38c1.7-1.6,3.84-2.66,6.78-2.66c4.48,0,7.52,2.5,7.52,6.5v0.06c0,4.03-2.91,5.86-6.46,6.46l-0.13,1.47c-0.13,0.7-0.64,1.28-1.38,1.28H24.31z M24.31,31.69c1.31,0,2.27,0.96,2.27,2.21v0.32c0,1.25-0.96,2.21-2.27,2.21c-1.31,0-2.27-0.96-2.27-2.21V33.9C22.04,32.65,23,31.69,24.31,31.69z"/>
          <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
          <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
          <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
        </svg>
        <div class="callout-block-heading-copy">
          <div class="callout-block-heading-copy-eyebrow">{{ $t('incomplete-principle') }}</div>
          <div class="callout-block-heading-copy-title">{{ $t('information-missing-for-this-principle') }}</div>
        </div>
      </div>

      <div class="callout-block-typography-section typography">
        <p v-if="$i18n.locale === 'fr'">
          Il manque des informations plus haut dans ce formulaire pour compléter ce principe. Veuillez cliquer sur <em>Continuer</em> pour faire défiler le formulaire et remplir les informations manquantes pour toute question sans réponse.
        </p>
        <p v-else>
          There is information missing earlier on this form to complete this principle. Please click <em>Continue</em> to scroll up and fill in the missing information for any unanswered questions.
        </p>
      </div>

      <div class="callout-block-actions">
        <div class="callout-block-actions-label">
          <div class="callout-block-actions-label-eyebrow">{{ $t('continue') }}</div>
          <div class="callout-block-actions-label-title">{{ $t('please-complete-principle') }}</div>
        </div>
        <div class="callout-block-actions-buttons">
            <button type="button" class="rect" @click.prevent="scrollToIncompleteQuestion">{{ $t('continue') }}</button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="callout-block-heading">
        <svg class="block-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
          <path fill="#0095ff" d="M16.2,31.05l-5.02-5.02c-0.78-0.78-2.05-0.78-2.83,0c-0.78,0.78-0.78,2.05,0,2.83l6.44,6.44c0.39,0.39,0.9,0.59,1.41,0.59c0.51,0,1.02-0.2,1.41-0.59l1.41-1.41L16.2,31.05L16.2,31.05z"/>
          <path fill="#0095ff" d="M30.82,22.08l2.05-2.05c0.78-0.78,0.78-2.05,0-2.83c-0.78-0.78-2.05-0.78-2.83,0l-8.89,8.89l2.83,2.83L30.82,22.08z"/>
          <path fill="#0061A6" d="M23.98,35.88c-0.51,0-1.02-0.2-1.41-0.59l-6.44-6.44c-0.78-0.78-0.78-2.05,0-2.83c0.78-0.78,2.05-0.78,2.83,0l5.02,5.02l13.84-13.84c0.78-0.78,2.05-0.78,2.83,0c0.78,0.78,0.78,2.05,0,2.83L25.39,35.29C25,35.68,24.49,35.88,23.98,35.88z"/>
          <path fill="#D91C1C" d="M25,4c7.76,0,14.53,4.24,18.17,10.51l3.48-2.01C42.33,5.03,34.25,0,25,0S7.67,5.03,3.35,12.5l3.48,2.01C10.47,8.24,17.24,4,25,4z"/>
          <path fill="#FFAC26" d="M46,25c0,11.58-9.42,21-21,21v4c13.81,0,25-11.19,25-25c0-4.55-1.22-8.82-3.35-12.5l-3.48,2.01C44.96,17.6,46,21.18,46,25z"/>
          <path fill="#00C2AE" d="M25,50v-4C13.42,46,4,36.58,4,25c0-3.82,1.04-7.4,2.83-10.49L3.35,12.5C1.22,16.18,0,20.45,0,25C0,38.81,11.19,50,25,50z"/>
        </svg>
        <div class="callout-block-heading-copy">
          <div class="callout-block-heading-copy-eyebrow">{{ $t('assessment-complete') }}</div>
          <div class="callout-block-heading-copy-title">{{ $t('congratulations-exclamation') }}</div>
        </div>
      </div>

      <div class="callout-block-typography-section typography">
        <p>
          {{ $t('assessment-complete-message') }} <em>{{ submission.name }}</em>.
        </p>
      </div>

      <div class="callout-block-actions">
        <div class="callout-block-actions-label">
          <div class="callout-block-actions-label-eyebrow">{{ $t('next-steps') }}</div>
          <div class="callout-block-actions-label-title"> {{ $t('view-report-complete-survey') }}</div>
        </div>
        <div class="callout-block-actions-buttons">
          <button type="button" class="rect" @click="onDownloadReport(submission.id)">{{ $t('download-report') }}</button>
          <a target="_blank" :href="$t('survey-url')">
            <button type="button" class="rect">{{ $t('complete-survey') }}</button>
          </a>
        </div>
      </div>
    </template>

  </div>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import {getCurrentInstance, inject, onMounted, onUnmounted, ref } from 'vue';
import QualityMentoringForm from '../../models/QualityMentoringForm';
import { getLocale } from '../../../../core/Utils';
import Manager from "../../../../core/Manager";
import RestService from 'restService';
import { onDownloadReport } from '../../../../core/Utils';

const form: QualityMentoringForm = inject('form');
const currentPageId = parseInt(useRoute().params.id as string)

const currentPage = form.pages.find((page) => page.id === currentPageId);
let incompletePages = form.pages.filter((page) => page.percentComplete < 100);
let nextPage = incompletePages.find((page) => page.id < currentPageId);
if (!nextPage) {
  nextPage = incompletePages.find((page) => page.id > currentPageId);
}
const submission = Manager.getInstance().submission

let pageComplete = ref(currentPage.percentComplete === 100);

const instance = getCurrentInstance();

const scrollToIncompleteQuestion = () => {
  instance.emit('scrollToNextQuestion');
}

onMounted(() => {
  document.body.addEventListener('updateCompleteMessage', updateCompleteMessage);
});

onUnmounted(() => {
  document.body.removeEventListener('updateCompleteMessage', updateCompleteMessage);
});

const updateCompleteMessage = () => {
  pageComplete.value = currentPage.percentComplete === 100;
  incompletePages = form.pages.filter((page) => page.percentComplete < 100);
  nextPage = incompletePages.find((page) => page.id < currentPageId);
  if (!nextPage) {
    nextPage = incompletePages.find((page) => page.id > currentPageId);
  }
}
</script>
